export function secondsToDhms(endTime: number) {
  const now = Math.floor(Date.now() / 1000);
  const seconds = Number(endTime) - now;

  const d = Math.floor(seconds / (3600 * 24));
  const h = Math.floor((seconds % (3600 * 24)) / 3600);
  const m = Math.floor((seconds % 3600) / 60);

  const dDisplay = d > 0 ? d + 'd ' : '0d ';
  const hDisplay = h > 0 ? h + 'h ' : '0h ';
  const mDisplay = m > 0 ? m + 'm' : '0m';
  return dDisplay + hDisplay + mDisplay;
}
